import { FrontEndColumn } from '../interfaces/front-end-column';
import { Observable, tap } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OdataResponse } from '../interfaces/odata-response';
import { AttributeIdsValue } from '../interfaces/AttributeIdsValue';
import { AppConfigService } from './app-config.service';

@Injectable({
  providedIn: 'root',
})
export class ConnectionService {
  constructor(private http: HttpClient) { }

  allEntityData(endPoint: string, tapCallback: (d: OdataResponse) => void) {
    let columns: FrontEndColumn[] = [];
    columns.push({
      name: 'Id',
      filterApplied: false,
      label: '',
      sortable: false,
      filterable: false,
      filterType: 0,
    });
    columns.push({
      name: 'Name',
      filterApplied: false,
      label: '',
      sortable: false,
      filterable: false,
      filterType: 0,
    });

    let queryParams = this.getQueryParameters(
      '',
      '',
      columns,
      -1,
      0,
      false,
      {},
      0
    );

    this.list(endPoint, queryParams, tapCallback);
  }

  query(
    endPoint: string,
    pageSize: number,
    pageIndex: number,
    sortBy: string,
    sortDirection: string | undefined,
    columns: FrontEndColumn[],
    filters: { [name: string]: any },
    tapCallback: (d: OdataResponse) => void,
    count: boolean = true,
    language: number = 0
  ) {
    let queryParams = this.getQueryParameters(
      sortBy,
      sortDirection,
      columns,
      pageIndex,
      pageSize,
      count,
      filters,
      endPoint.endsWith('ProductStatus') ||
        endPoint.endsWith('DisplayProperties') ||
        endPoint.endsWith('Relationship') ? 0 : language
    );


    this.list(endPoint, queryParams, tapCallback);
  }

  details(
    endPoint: string,
    id: number,
    tapCallback: (d: any) => void,
    expandStr: string = ''
  ) {
    if (expandStr != null) {
      const request = this.http.get(endPoint + '/' + id + expandStr);
      this.processRequest(request, tapCallback);
    } else {
      const request = this.http.get(endPoint + '/' + id);
      this.processRequest(request, tapCallback);
    }
  }

  create(endPoint: string, record: any, tapCallback: (d: any) => void) {
    const request = this.http.post(endPoint, record);
    this.processRequest(request, tapCallback);
  }

  patch(
    endPoint: string,
    id: number,
    record: any,
    tapCallback: (d: any) => void
  ) {
    const request = this.http.patch(endPoint + '/' + id, record);
    this.processRequest(request, tapCallback);
  }

  put(
    endPoint: string,
    id: number,
    record: any,
    tapCallback: (d: any) => void
  ) {
    const request = this.http.put(endPoint + '/' + id, record);
    this.processRequest(request, tapCallback);
  }

  get(endPoint: string, tapCallback: (d: any) => void) {
    const request = this.http.get(endPoint);
    this.processRequest(request, tapCallback);
  }

  delete(endPoint: string, id: number, tapCallback: (d: any) => void) {
    const request = this.http.delete(endPoint + '/' + id);
    this.processRequest(request, tapCallback);
  }

  private getQueryParameters(
    sortBy: string,
    sortDirection: string | undefined,
    columns: FrontEndColumn[],
    pageIndex: number,
    pageSize: number,
    count: boolean,
    filters: {
      [name: string]: {
        value: string;
        numberFromValue: number | string;
        numberToValue: number | string;
      };
    },
    language: number
  ) {
    let expand = '';
    let queryParams = new HttpParams();
    if (columns.length > 0) {
      let select = '';
      let attributeSelect = '';

      columns.forEach((c) => {
        if (c.ignoreInAPI) {
          return;
        }

        if (c.name.startsWith('Attribute.')) {
          attributeSelect += c.name.replace('Attribute.', '') + ',';
        } else {
          select += c.name + ',';
        }
      });

      select = select.replace(/,\s*$/, '');
      queryParams = queryParams.append('select', select);
      if (attributeSelect !== '') {
        attributeSelect = attributeSelect.replace(/,\s*$/, '');
        expand = `AttributeValues(select=Id,Value,AttributeId,MediaObjectId,LanguageId;expand=MediaObject(expand=Media),OptionValue;filter=LanguageId in (0,${language}) and AttributeId in (${attributeSelect}))`;
      }
    }

    if (count) {
      queryParams = queryParams.append('count', true);
    }

    //Check if any filter contains empty text or a num value 
    const hasTextOrNumberFilter = Object.keys(filters).some(key => {
      const filter = filters[key];
      return (
        (filter.value && filter.value.trim() !== '') ||
        (filter.numberFromValue != null || filter.numberToValue != null)
      );
    });




    if (hasTextOrNumberFilter) {
      queryParams = queryParams
        .append('skip', 0)
        .append('top', pageSize);
    } else if (pageIndex != -1 && pageSize != 0) {
      queryParams = queryParams
        .append('skip', pageIndex * pageSize)
        .append('top', pageSize);
    }
    if (
      sortBy != null &&
      sortBy != '' &&
      sortDirection != null &&
      sortDirection != ''
    ) {
      queryParams = queryParams.append('orderby', `${sortBy} ${sortDirection}`);
    }

    const filtersArray: string[] = [];
    Object.keys(filters).forEach((key) => {
      const column = columns.find((c) => c.name === key);
      if (
        filters[key] != null &&
        (filters[key].value != null ||
          filters[key].numberFromValue != null ||
          filters[key].numberToValue != null)
      ) {
        let filterApplied = false;
        if (filters[key].value != null) {
          if (typeof filters[key].value === 'string')
            filtersArray.push(
              `(contains(${key}, '${filters[key].value.replace("'", "''")}'))`
            );
          if (typeof filters[key].value === 'number')
            filtersArray.push(`(${key} eq ${filters[key].value})`);
          filterApplied = true;
        } else {
          if (
            filters[key].numberFromValue != null &&
            filters[key].numberFromValue != ''
          ) {
            filtersArray.push(`(${key} ge ${filters[key].numberFromValue})`);
            filterApplied = true;
          }
          if (
            filters[key].numberToValue != null &&
            filters[key].numberToValue != ''
          ) {
            filtersArray.push(`(${key} le ${filters[key].numberToValue})`);
            filterApplied = true;
          }
        }

        if (column != null) {
          column.filterApplied = filterApplied;
        }
      } else {
        if (column != null) {
          column.filterApplied = false;
        }
      }
    });

    if (filtersArray.length > 0) {
      queryParams = queryParams.append('filter', filtersArray.join(' and '));
    }

    if (language !== 0) {
      if (expand === '') {
        expand += `Translations(select=Id,ObjectField,Label;filter=LanguageId eq ${language})`;
      } else {
        expand += `,Translations(select=Id,ObjectField,Label;filter=LanguageId eq ${language})`;
      }
    }

    if (expand !== '') {
      queryParams = queryParams.append('expand', expand);
    }

    return queryParams;
  }

  private list(
    endPoint: string,
    parameters: HttpParams,
    tapCallback: (d: OdataResponse) => void
  ) {
    const request = this.http.get(endPoint, {
      params: parameters,
    });

    this.processRequest(request, tapCallback);
  }

  private processRequest(
    request: Observable<Object>,
    tapCallback: (d: any) => void
  ) {
    const subscription = request
      .pipe(
        tap((d: any) => {
          tapCallback(d);
          subscription.unsubscribe();
        })
      )
      .subscribe();
  }

  fetchData(endPoint: string, tapCallback: (d: OdataResponse) => void) {
    const request = this.http.get(endPoint);

    this.processRequest(request, tapCallback);
  }

  updateBulkAttribute(
    objectId: number,
    objType: number,
    language: number,
    requestBody: AttributeIdsValue[],
    tapCallback: (d: any) => void
  ) {
    const link = `${AppConfigService.settings.apiUrl}BulkEdit/UpdateBulkAttribute/${objectId}/${objType}/${language}`;
    const request = this.http.patch(link, requestBody);
    const subscription = request
      .pipe(
        tap((d: any) => {
          tapCallback(d);
          subscription.unsubscribe();
        })
      )
      .subscribe();
  }

}
